import { graphql } from 'react-relay';

export const searchHometaxRefundResult = graphql`
  mutation searchHometaxRefundResultMutation($refundToken: String!, $code: String!) {
    searchHometaxRefundResult(refundToken: $refundToken, code: $code) {
      result
      errors {
        code
        message
      }
      taxpayerName
      hometaxRefundResult
    }
  }
`;

export const searchHometaxRefundReload = graphql`
  mutation searchHometaxRefundReloadMutation($refundToken: String!, $code: String!) {
    reload(refundToken: $refundToken, code: $code) {
      result
      errors {
        code
        message
      }
      taxpayerName
    }
  }
`;

export const searchHometaxRefundLoadEmployeeIncrease = graphql`
  mutation searchHometaxRefundLoadEmployeeIncreaseMutation($refundToken: String!, $code: String!) {
    loadEmployeeIncrease(refundToken: $refundToken, code: $code) {
      result
      errors {
        code
        message
      }
      taxpayerName
    }
  }
`;
